import convertDisplayName from './convertDisplayName';
import servicesData from './fetchdata';

/**
 * Sort JavaScript Object
 * CF Webtools : Chris Tierney
 * obj = object to sort
 * order = 'asc' or 'desc'
 *
 * Credit: https://gist.github.com/CFJSGeek/5550678
 */
function sortObj(obj, order) {
  // let key;


  const tempArry = [];


  let i;


  const tempObj = {};

  // for (key in obj) {
  Object.keys(obj).forEach((key) => {
    tempArry.push(key);
  });

  tempArry.sort(
    (a, b) => a.toLowerCase().localeCompare(b.toLowerCase()),
  );

  if (order === 'desc') {
    for (i = tempArry.length - 1; i >= 0; i -= 1) {
      tempObj[tempArry[i]] = obj[tempArry[i]];
    }
  } else {
    for (i = 0; i < tempArry.length; i += 1) {
      tempObj[tempArry[i]] = obj[tempArry[i]];
    }
  }

  return tempObj;
}

// function sortStringData(data, sortvalue, sortreverse) {
//   const sortBy = (field, reverse, primer) => {
//     const key = primer
//       ? x => primer(x[field])
//       : x => x[field];

//     const reverse1 = !reverse ? 1 : -1;

//     return (a, b) => {
//       const a1 = key(a);
//       const b1 = key(b);
//       const r1 = reverse1 * ((a1 > b1) - (b1 > a1));
//       return r1;
//     };
//   };

//   let sortorder = true;
//   if (sortreverse !== undefined && !sortreverse) {
//     sortorder = false;
//   }

//   if (data[0]) {
//     return data.sort(sortBy(sortvalue, sortorder));
//   }
//   return data;
// }

const processApiServicesData = (data) => {
  let rawData = []; // data;
  let tempTuple = {};
  const finalData = [];

  rawData = data;
  if (rawData.getAPIServices.length === 0) {
    rawData.getAPIServices = { ...servicesData };
  } else {
    const sortedData = sortObj(rawData.getAPIServices, 'asc');
    rawData.getAPIServices = { ...sortedData };
  }

  Object.keys(rawData.getAPIServices).forEach((key) => {
    if (rawData.getAPIServices[key] !== undefined) {
      const serviceName = rawData.getAPIServices[key];
      const displayName = convertDisplayName(serviceName);
      tempTuple.serviceName = serviceName;
      tempTuple.displayName = displayName;

      finalData.push(tempTuple);
      tempTuple = {};
    }
  });

  return finalData;
};

export default processApiServicesData;
